import React from "react";
import heroVideo from "../assets/video/hero-video.mp4";
import Header from "./common/Header";

function Hero() {
  return (
    <>
      <div className="max-w-[1920px] mx-auto">
        <Header />
        <div className="2xl:max-w-[1470px] xl:max-w-[1240px] lg:px-5 md:px-8 px-5 mx-auto container 2xl:pt-[136px] lg:pt-[129px] md:pt-[113px] sm:pt-24 pt-16">
          <h1 className="sm:max-w-[1184px] max-w-[350px] xl:text-custom-7xl lg:text-custom-6xl md:text-custom-56 sm:text-5xl text-custom-5xl font-normal leading-92 text-dark-purple tracking-2 mt-[44px] relative z-10">
            For the left curvers,&nbsp;
            <span className="text-light-purple inline-block">
              believers,&nbsp;
            </span>
            and top blasters - Welcome to&nbsp;
            <span className="text-light-purple inline-block"> Dunce Coin.</span>
          </h1>
        </div>
        <video
          loop
          autoPlay
          muted
          src={heroVideo}
          playsInline
          // className="w-full h-auto sm:h-full max-h-[450px] max-sm:min-h-[350px] object-cover custom-1800:object-fill md:top-[450px] sm:top-[350px] top-[360px] left-0 z-[5] mt-8 sm:max-h-[1080px]"
          // @review - update the following to include any specific margins/padding?
          className="w-full h-auto max-h-[450px] sm:max-h-[1080px] object-cover"
        ></video>
      </div>
    </>
  );
}

export default Hero;
